var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "product-card-wrapper"
  }, [_c("a-row", {
    attrs: {
      gutter: [24, 24]
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("a-col", {
      key: index,
      attrs: {
        span: 12
      }
    }, [_c("div", {
      staticClass: "product-card",
      on: {
        click: function ($event) {
          return _vm.handleClick(item);
        }
      }
    }, [_c("div", {
      staticClass: "product-card-content"
    }, [_c("h4", [_vm._v(" " + _vm._s(item.name) + " "), _vm.isLink ? _c("span", {
      staticClass: "product-card-icon"
    }, [_c("img", {
      attrs: {
        src: require("@/assets/images/homepage/arrow.png"),
        alt: "pctmn-ai"
      }
    })]) : _vm._e()]), _c("p", {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc))])])])]);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };